export default "__VITE_ASSET__DQYuJ7ac__"